export class Email {
  static looksLikeMail(str) {
    return str.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/);
  }

  static emailWithSenderName(str) {
    const matches = str?.match(/([^<]+)*<([^>]+)>/);
    if (matches?.length === 3) {
      const name = matches[1];
      const email = matches[2];

      if (!Email.looksLikeMail(email)) {
        return null;
      }
      return { name: name.trim(), email: email.trim() };
    } else {
      return null;
    }
  }

  static validDomain(domainStr) {
    if (!domainStr) return false;

    return domainStr.match(
      /^(?!-)[A-Za-z0-9-]+([\-\.]{1}[a-z0-9]+)*\.[A-Za-z]{2,6}$/
    );
  }
}
